<template>
    <div id="regionData" class="sys-page">
        <p class="title">地区数据监控管理</p>
        <div class="addRegion">
            <el-button type="primary" size="small" @click="showARegion()">添加地区</el-button>
        </div>
        <section>
            <div class="elCard" v-for="(item,index) in regionList" :key="index">
                <p class="regionName">{{item.regionName}}</p>
                <div class="opera">
                    <el-button type="" size="small" @click="showERegion(item)">编辑</el-button>
                    <el-button type="danger" size="small" @click="delet(item.regionDataId)">删除</el-button>
                </div>
            </div>
        </section>
        <el-dialog class="contBox" center title="地区添加" :visible.sync="showAddRegion" width="1200px" @close="cancel">
            <el-form ref="addform" :model="addform" label-width="100px">
                <el-form-item label="地区名称：">
                    <el-input v-model="addform.regionName" style="width:45%;margin-right:10px;" placeholder="请输入地区名称"></el-input>
                </el-form-item>
                <el-form-item label="区域筛选：" style="width:100%;">
                    <city-select @hospAddArr='addArr=>{hospAddArr=addArr}' :hospCityArr='hospAddArr' style="width:100%;" />
                </el-form-item>
                <el-form-item label="选择医院：">
                    <el-transfer class="transfer"
                     :titles="['待选', '已选']"
                     filterable 
                     :props="{key: 'hospId',label: 'hospName'}"
                     :filter-method="filterMethod" 
                     filter-placeholder="请输入医院名称" 
                     v-model="addform.hospArray" 
                     :data="hospList">
                    </el-transfer>
                </el-form-item>
                <el-form-item style="display:flex;justify-content:flex-end">
                    <el-button type="primary" size="small" @click="submit">添加</el-button>
                    <el-button size="small" @click="showAddRegion=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog class="contBox" center title="地区编辑" :visible.sync="showEditRegion" width="1200px" @close="cancel">
            <el-form ref="editform" :model="editform" label-width="100px">
                <el-form-item label="地区名称：">
                    <el-input v-model="editform.regionName" style="width:36%;margin-right:10px;" placeholder="请输入地区名称"></el-input>
                </el-form-item>
                <el-form-item label="选择医院：">
                    <el-transfer class="transfer"
                     :titles="['待选', '已选']"
                     filterable 
                     :props="{key: 'hospId',label: 'hospName'}"
                     :filter-method="filterMethod" 
                     filter-placeholder="请输入医院名称" 
                     v-model="editform.hospArray" 
                     :data="hospList">
                    </el-transfer>
                </el-form-item>
                <el-form-item style="display:flex;justify-content:flex-end">
                    <el-button type="primary" size="small" @click="save">保存</el-button>
                    <el-button size="small" @click="showEditRegion=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import citySelect from '@/components/citySelect'
export default {
    name:'region',
    components:{
      'city-select':citySelect
    },
    data(){
        return{
            regionList:[],
            showAddRegion:false,
            addform:{
                regionName:'',
                hospArray:[],
            },
            showEditRegion:false,
            hospAddArr:[],//区域选择
            editform:{
                regionDataId:'',
                regionName:'',
                hospArray:[],
            },
            hospList:[],
            filterMethod(query, item) {
                return item.hospName.indexOf(query) > -1;
            }
        }
    },
    mounted(){
        this.getRegionList();
    },
    methods:{
        getRegionList(){
            this.$ajax.post(this.$domain.regionList,{})
            .then(ret=>{
                this.$common.getConsole('region.vue——获取地区列表',ret.data);
                if(ret.data.code==10){
                    this.regionList=ret.data.data.list;
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
            .catch(err=>{
                console.log('%c '+err,'color:red')
            })
        },
        showARegion(){
            this.showAddRegion=true;
            this.getHospList(null,0);
        },
        //显示地区编辑弹框
        showERegion(row){
            this.editform={
                regionDataId:row.regionDataId,
                regionName:row.regionName,
                hospArray:row.hospArray.split(','),
            };
            this.showEditRegion=true;
            this.getHospList(null,0);
        },
        //获得医院列表
        getHospList(code,level){
            this.$ajax.post(this.$domain.listByRegion,{
                code:code,
                level:level
            })
            .then(ret=>{
                this.$common.getConsole('region.vue——根据区域获得医院列表',ret.data);
                if(ret.data.code==10){
                    this.hospList=ret.data.data;
                }
                else if(ret.data.code==401){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
            .catch(err=>{
                console.log('%c '+err,'color:red')
            })
        },
        //创建区域信息
        submit(){
            console.log(this.addform)
            if(this.addform.hospArray.length==0){
                this.$message.error('请选择医院');
                return;
            }
            if(this.addform.regionName==''){
                this.$message.error('请输入区域名字');
                return;
            }
            this.$ajax.post(this.$domain.regionAdd,{
                hospArray:this.addform.hospArray.join(','),
                regionName:this.addform.regionName
            })
            .then(ret=>{
                this.$common.getConsole('region.vue——创建区域信息',ret.data);
                if(ret.data.code==10){
                    this.$message.success('地区创建成功！');
                    this.showAddRegion=false;
                    this.getRegionList();
                }
                else if(ret.data.code==401){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
            .catch(err=>{
                console.log('%c '+err,'color:red')
            })
        },
        delet(regionId){
            this.$confirm('此操作将永久删除该地区信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$ajax.post(this.$domain.regionDelete,{
                    regionDataId:regionId
                })
                .then(ret=>{
                    this.$common.getConsole('region.vue——删除区域信息',ret.data);
                    if(ret.data.code==10){
                        this.$message.success('地区删除成功！');
                        this.getRegionList();
                    }
                    else if(ret.data.code==401){
                        this.$message.error('登录失效，请重新登录!')
                        this.$router.push({path:'/login'});
                    }
                    else{
                        this.$message.error(ret.data.message);
                    }
                })
                .catch(err=>{
                    console.log('%c '+err,'color:red')
                })
            }).catch(() => {
                  
            });
            
        },
        save(){
            console.log(this.editform)
            if(this.editform.hospArray.length==0){
                this.$message.error('区域医院列表不能为空！');
                return;
            }
            if(this.editform.regionName==''){
                this.$message.error('区域名字不能为空');
                return;
            }
            this.$ajax.post(this.$domain.regionUpdate,{
                regionDataId:this.editform.regionDataId,
                regionName:this.editform.regionName,
                hospArray:this.editform.hospArray.join(',')
            })
            .then(ret=>{
                this.$common.getConsole('region.vue——修改区域信息',ret.data);
                if(ret.data.code==10){
                    this.$message.success('地区修改成功！');
                    this.showEditRegion=false;
                    this.getRegionList();
                }
                else if(ret.data.code==401){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
            .catch(err=>{
                console.log('%c '+err,'color:red')
            })
        },
        //关闭弹框
        cancel(){
            this.addform={
                regionName:'',
                hospArray:[],
            };
            this.editform={
                regionName:'',
                hospArray:[],
            };
            this.hospAddArr=[];
        },
    },
    watch:{
        hospAddArr(val){
            if(this.hospAddArr.length>0){
                this.addform.hospArray=[];
            }
            this.getHospList(val[val.length-1],val.length);
        }
    }
}
</script>

<style lang="scss">
#regionData{
    width:100%;
    height:100%;
    text-align: left;
    .title{
        color:#014093;
        font-size: 20px;
        width:80%;
        min-width:1000px;
        max-width:1400px;
        margin:30px auto;
        text-align:left;
    }
    .addRegion{
        color:#333;
        text-align: right;
        width:64%;
        min-width:1000px;
        max-width:1400px;
        margin: auto;
        margin-bottom:20px;
    }
    section{
        width:80%;
        min-width:1000px;
        max-width:1400px;
        margin: auto;
        text-align: left;
        .elCard{
            width:80%;
            margin:5px auto; 
            text-align:left;
            padding:20px;
            box-sizing: border-box;
            font-size: 18px;
            border:1px solid #ccc;
            border-radius: 4px;
            color:#333;
            display: flex;
            justify-content: space-between;
            .transfer{
                text-align: left;
            }
        }
        .regionName:hover{
            color: #5C6BC0;
            cursor: pointer;
        }
        .edit{
            cursor: pointer;
        }
        .edit:hover{
            color:rgb(216, 119, 8)
        }
    }
    .contBox{
        padding:0px 10%;
        box-sizing: border-box;
        .el-cascader{
            width:45%;
        }
        .el-transfer{
            width:100%;
            .el-transfer-panel{
                width:450px!important;
            }
        }
    }
    .el-form-item__content{
        text-align: left!important;
    }
    .el-card__body{
        padding:0!important;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/regionData.vue